import React from 'react';

import { NavLink } from 'react-router-dom';
import { hasPermission } from '../../auth/authUtils';
import UserPopup from '../../popups/user';
import permissionTypes from '../../../constants/permissionTypes';
import { useAppSelector } from '../../../hooks';

export interface UserLinkProps {
  id: number | null;
  name: string | null;
  className?: string;
  imageSize?: number;
}
function UserLink({ id, name, className, imageSize }: UserLinkProps) {
  const currentUser = useAppSelector((state) => state.auth);

  return (
    <>
      {id && name ? (
        hasPermission(currentUser, permissionTypes.MANAGE_USERS) ? (
          <UserPopup id={id}>
            <span className={className}>
              <NavLink to={`/user/${id}`}>{name}</NavLink>
            </span>
          </UserPopup>
        ) : (
          name
        )
      ) : name ? (
        name
      ) : (
        '-'
      )}
    </>
  );
}

export default UserLink;
